import React, { useState, useEffect, useRef } from 'react';
import Fab from '@mui/material/Fab';
import FilterListIcon from '@mui/icons-material/FilterList';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import CloseIcon from '@mui/icons-material/Close';
import Dashboard from '@mui/icons-material/Dashboard';
import { Menu, MenuItem, Tooltip, IconButton, Autocomplete, TextField, Button, Dialog, Slider, Typography, ImageList, ImageListItem, ImageListItemBar, DialogContent, Checkbox } from '@mui/material';

import useS3Upload from './useS3Upload'

import { getUniqueValuesGeoJsonField, makeMetricsByInsightCategoryDict} from './DataPrep';

import { listDataCollectionDates, listDataVineyards, getGeoJsonFromS3, getGZSummaryTableFromS3 } from './DataRetrieval';
import { getJsonFromS3 } from './views/LandingDashboard/KPICards/KPIS3';

import { DataProvider, useDataSetters, useDataState } from '../DataContext';


// Custom Autocomplete component for better modularity
const CustomAutocomplete = ({ id, label, options, value, onChange }) => (
  <Autocomplete
    id={id}
    options={options}
    sx={{ width: 300, pb: 2, padding: '10px' }}
    renderInput={(params) => <TextField {...params} label={label} />}
    value={value}
    onChange={onChange}
  />
);

const CustomMultiAutocomplete = ({ id, label, options, value, onChange }) => (
  <Autocomplete
    multiple
    id={id}
    options={options}
    sx={{ width: 300, pb: 2, padding: '10px' }}
    renderInput={(params) => <TextField {...params} label={label} />}
    value={value}
    onChange={onChange}
  />
);

const FloatingInputMenu = (props) => {

  // App state management; see DataContext.js
  const {
    currentUser,
    userGroups,
    userGroup,
    geoJsonVineData,
    selectedBucket,
    bucketOptions,
    vineyardOptions,
    selectedVineyard,
    dateOptions,
    selectedDate,
    blockNames,
    selectedBlockName,
    selectedYear,
    vineyardSummaryData,
    geoJsonVineDataImgUrls,

    // Infrastructure asset
    isInfraAssetClicked,
    
    // Plant asset class (i.e. maturity level) panel
    isMaturityClassClicked,

  } = useDataState();

  const {
    setLandingDashboardOpen,
    setVineyardSummaryData,
    setUserGroups,
    setUserGroup,
    setSelectedBucket,
    setBucketOptions,
    setVineyardOptions,
    setSelectedVineyard,
    setSelectedDate,
    setSelectedYear,
    setDateOptions,
    setBlockNames,
    setSelectedBlockName,
    setCurrentUserView,
    setGeoJsonVineDataImgUrls,
    setKpiSettingsTable,

    // Plant asset class (i.e. maturity level) panel
    setIsMaturityClassClicked,

    // Infrastructure asset
    setIsInfraAssetClicked,

  } = useDataSetters();

  // Local state management for data menu
  const [selectedMenuBucket, setSelectedMenuBucket] = useState(selectedBucket);
  const [selectedMenuVineyard, setSelectedMenuVineyard] = useState(selectedVineyard);
  const [selectedMenuDate, setSelectedMenuDate] = useState(selectedDate);
  const [selectedMenuBlockName, setSelectedMenuBlockName] = useState(selectedBlockName);

  // Relic state variables
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);
  // const [userGroup, setUserGroup] = useState(props.selectedGroup);
  // const [userGroups, setUserGroups] = useState(props.userGroups || []);
  const [isAdmin, setIsAdmin] = useState(false);
  // const [selectedBucket, setSelectedBucket] = useState(props.selectedBucket);
  // const [bucketOptions, setBucketOptions] = useState([]);
  // const [selectedVineyard, setSelectedVineyard] = useState(props.selectedVineyard);
  // const [vineyardOptions, setVineyardOptions] = useState(props.vineyardOptions);
  // const [selectedDate, setSelectedDate] = useState(props.selectedDate);
  // const [dateOptions, setDateOptions] = useState(props.dateOptions);
  // const [blockNames, setBlockNames] = useState(props.blockNames)
  // const [selectedBlockName, setSelectedBlockName] = useState(props.selectedBlockName || ['All Blocks']);
  const [selectedInsightCategory, setSelectedInsightCategory] = useState(props.selectedInsightCategory);
  const [selectedInsightMetric, setSelectedInsightMetric] = useState(props.selectedInsightMetric);
  const [insightMetricOptions, setInsightMetricOptions] = useState(props.insightMetrics);
  const [selectedSliderRange, setSelectedSliderRange] = useState(props.selectedSliderRange);
  // const [geoJsonVineDataImgUrls, setGeoJsonVineDataImgUrls] = useState(props.geoJsonVineDataImgUrls);
  const [dataCaptureDate, setDataCaptureDate] = React.useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  
  const { selectedFiles, handleFileInput, uploadToS3, uploadProgress, uploadStatus } = useS3Upload();

  const fileInput = React.useRef();

  const prevBlockNameRef = useRef();

  // Insight metric options setup
  const getInsightMetricOptions = (selectedBucket) => {
    const insightMetricOptions = makeMetricsByInsightCategoryDict(selectedBucket)
    setInsightMetricOptions(insightMetricOptions)
  }

  useEffect(() => {
    getInsightMetricOptions(selectedBucket)
  }, [userGroup, selectedBucket])

  useEffect(() => {
    setGeoJsonVineDataImgUrls(geoJsonVineDataImgUrls);
  }, [geoJsonVineDataImgUrls]);

  const updateIsAdmin = (value) => {
    setIsAdmin(value);
    console.log('isAdmin: ', value);
  };

  useEffect(() => {
    console.log('isAdmin: ', isAdmin);
  }, [isAdmin]);


  // Hook to grab S3 subdirectories for specified user group and define if admin
  useEffect(() => {
    console.log('userGroups here', userGroups);
    setUserGroups(userGroups);
    if (Array.isArray(userGroups) && userGroups.length > 1){
      updateIsAdmin(true);
      
    } else {
      updateIsAdmin(false);
    };

    setBucketOptions(userGroups);
    setBlockNames(blockNames);
    // setSelectedBlockName(['All Blocks']);
    console.log('userGroup', userGroup)
  }, [userGroup, selectedBucket, userGroups, blockNames]);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleImageViewerClick = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleS3UploaderClick = (event) => {
    setAnchorEl3(event.currentTarget);
  };

  // Closes the dialog and sends the selected values to the parent component
  const closeFilterMenu = () => {
    setAnchorEl(null);
  };

  const closeImageViewer = () => {
    setAnchorEl2(null)
  }

  const closeS3Uploader = () => {
    setAnchorEl3(null);
    setDataCaptureDate(null);
  }
  

  // Function to convert MMDDYYYY string to YYYY-MM-DD format
  function convertToDateString(dateString) {
    const month = dateString.slice(0, 2);
    const day = dateString.slice(2, 4);
    const year = dateString.slice(4, 8);
    return `${year}-${month}-${day}`;
  }

  // Function to convert a Date object back to MMDDYYYY format
  function formatDateToMMDDYYYY(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}${day}${year}`;
  }

  // This will run whenever state1 or state2 changes
  useEffect(() => {

    if (loading || selectedVineyard[0] === 'Loading...' || selectedDate[0] === 'Loading...' || dateOptions[0] === 'Loading...' || selectedBlockName[0] === 'Loading...' || blockNames[0] === 'Loading...') {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [selectedBucket, selectedVineyard, selectedDate, dateOptions, selectedBlockName, blockNames, loading]);

  
  // Handle menu dropdown options
  const handleMenuOptions = async (value) => {
    setLoading(true);
    
    // update selected Client (i.e. bucket) in Menu
    setSelectedMenuBucket(value);

    // update vineyard options in menu
    const dataVineyards = await listDataVineyards(value);
    setVineyardOptions(dataVineyards);
    setSelectedMenuVineyard(dataVineyards[0]);

    // update collection date options in menu
    const dataCollectionDates = await listDataCollectionDates(value, dataVineyards[0]);
    setDateOptions(dataCollectionDates);
    
    // Function to get the year from MMDDYYYY format
    function getYear(dateString) {
      return parseInt(dateString.slice(-4));
    }

    // Find the most recent year
    const mostRecentYear = Math.max(...dataCollectionDates.map(getYear));

    // Filter dates by the most recent year and find the most recent full date
    const mostRecentDate = dataCollectionDates
      .filter(date => getYear(date) === mostRecentYear)
      .reduce((maxDate, currentDate) => (currentDate > maxDate ? currentDate : maxDate), '');

    // Use the most recent date for setSelectedMenuDate
    setSelectedMenuDate(mostRecentDate);
    // setSelectedMenuDate(dataCollectionDates[dataCollectionDates.length - 1]);

    // update block name options in menu
    const block_data = await getGeoJsonFromS3(`${value}/${dataVineyards[0]}/block_boundaries/boundaries.geojson`, userGroup, props.fileBlocksDataCache, props.setFileBlocksDataCache);
    const block_names = await getUniqueValuesGeoJsonField(block_data, 'block_name');
    block_names.push('All Blocks');
    // setBlockNames(block_names);
    setSelectedMenuBlockName(['All Blocks']);

    setLoading(false);
  }

  // Handle menu
  const handleVineyardMenuChange = async (value) => {
    setLoading(true);

    // update selected Client in Menu
    setSelectedMenuVineyard(value)

    // update collection date options in menu
    const dataCollectionDates = await listDataCollectionDates(selectedMenuBucket, value);
    setDateOptions(dataCollectionDates);
    setSelectedMenuDate(dataCollectionDates[dataCollectionDates.length - 1]);

    // update block name options in menu
    const block_data = await getGeoJsonFromS3(`${selectedMenuBucket}/${value}/block_boundaries/boundaries.geojson`, userGroup, props.fileBlocksDataCache, props.setFileBlocksDataCache);
    const blockNames = await getUniqueValuesGeoJsonField(block_data, 'block_name');
    blockNames.push('All Blocks');
    // setBlockNames(blockNames);
    setSelectedMenuBlockName(['All Blocks']);

    setLoading(false);
  };
  

  // Handle Submit button
  const handleGroupSubmit = async (newGroup) => {
    setSelectedBucket(newGroup)
  };

  const handleBucketSubmit = async (newBucket) => {
    setLoading(true);
    const vineyard_summary_data = await getGZSummaryTableFromS3(`${newBucket}/${selectedMenuVineyard}/kit_insights/Summary_${selectedYear}/summary.csv.gz`, userGroup);
    const kpiData = await getJsonFromS3(`${newBucket}/${selectedMenuVineyard}/kit_insights/Summary_${selectedYear}/kpiSettingsTable.json`);
    console.log('kpiData from handleBucketSubmit: ', kpiData)
    setVineyardSummaryData(vineyard_summary_data);
    setSelectedBucket(newBucket);
    if (newBucket === 'acierno') {
      setSelectedInsightCategory('Vine Health');
      setSelectedInsightMetric('Trunk thickness (in.)');
    }
    setSelectedVineyard(selectedMenuVineyard);
    setSelectedDate(selectedMenuDate);
    setSelectedYear(selectedMenuDate.slice(-4));
    console.log('selected year kitdatamenu:', selectedMenuDate.slice(-4));
    setKpiSettingsTable(kpiData);
    setLoading(false);
  };

  const handleVineyardSubmit = async (newVineyard) => {
    setSelectedVineyard(newVineyard);
  }

  const handleDateSubmit = async (newDate) => {
    setSelectedDate(newDate);
    setSelectedYear(newDate.slice(-4));
    console.log('selected year kitdatamenu handleDateSubmit:', newDate.slice(-4));
  };

  const handleBlockNameSubmit = async (newBlockName) => {
    setSelectedBlockName(newBlockName);
  };

  // Handle dashboard open
  const handleDashboardOpen = () => {
    setCurrentUserView('Dashboard');
    setLandingDashboardOpen(true);
  };

  // Maintain existing filtering based on date change within vineyard
  useEffect(() => {
    setSelectedBlockName(selectedMenuBlockName);
  }, [geoJsonVineData])

  // Handle block name changes
  useEffect(() => {
    // Store current value in our ref
    prevBlockNameRef.current = selectedBlockName;
  }, [selectedBlockName]);
  
  const prevBlockName = prevBlockNameRef.current;

  // Handle insight category change
  const handleInsightCategoryChange = (value) => {
    setSelectedInsightCategory(value);
    setSelectedInsightMetric(insightMetricOptions[value][0]);
  };

  // Handle plant asset class viewing on map
  const handleIsMaturityClassClicked = () => {
    setIsMaturityClassClicked(!isMaturityClassClicked);
  };

  // Handle plant asset class viewing on map
  const handleIsInfraAssetClicked = () => {
    setIsInfraAssetClicked(!isInfraAssetClicked);
  };

  // Handles menu button press
  const handleSubmit = () => {
    handleGroupSubmit(selectedMenuBucket);
    handleBucketSubmit(selectedMenuBucket);
    handleVineyardSubmit(selectedMenuVineyard);
    handleDateSubmit(selectedMenuDate);
    handleBlockNameSubmit(selectedMenuBlockName);
    props.onInsightCategoryChange(selectedInsightCategory);
    props.onInsightMetricChange(selectedInsightMetric);
    props.onSelectedSliderRange(selectedSliderRange);
  };

  // Render menu components
  return (
    <>
      <Tooltip title={<Typography sx={{ fontSize: 14 }}>Dashboard View</Typography>}>
          <Fab
              color="primary"
              aria-label="landing-dashboard-viewer"
              onClick={handleDashboardOpen}
              style={{ position: 'fixed', top: '70px', right: '10px' }}
          >
              <Dashboard color="primary.dark" />
          </Fab>
      </Tooltip>
      <Tooltip title={<Typography sx={{ fontSize: 14 }}>Select data for insights</Typography>}>
        <Fab
          color="primary"
          aria-label="add"
          onClick={handleFilterClick}
          style={{ position: 'fixed', top: '140px', right: '10px' }}
        >
          <FilterListIcon />
        </Fab>
      </Tooltip>
      
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={closeFilterMenu}
        disableRipple
      >
        {isAdmin && (
          <MenuItem>
            <CustomAutocomplete
              id="bucket-selector"
              label="Client"
              options={bucketOptions}
              value={selectedMenuBucket}
              onChange={(_, value) => handleMenuOptions(value)}
            />
          </MenuItem>
        )}
        
        <MenuItem>
          <CustomAutocomplete 
            id="vineyard-selector" 
            label="Vineyard"
            options={vineyardOptions}
            value={selectedMenuVineyard}
            onChange={(_, value) => handleVineyardMenuChange(value)}
          />
        </MenuItem>
        
        <MenuItem>
          <CustomAutocomplete
            id="date-selector"
            label="Date"
            options={dateOptions}
            value={selectedMenuDate}
            onChange={(_, value) => setSelectedMenuDate(value)}
          />
        </MenuItem>
        <MenuItem>
        {console.log("blockNames:", blockNames, Array.isArray(blockNames))}
        {console.log("selectedBlockName:", selectedBlockName, Array.isArray(selectedBlockName))}

          <CustomMultiAutocomplete
            id="block-id-selector"
            label="Block ID"
            options={blockNames}
            value={selectedMenuBlockName}
            onChange={(_, value) => {
              console.log("Initial value:", value, Array.isArray(value));
              if (value.includes('All Blocks') && (!prevBlockName || !prevBlockName.includes('All Blocks'))) {
                value = ['All Blocks'];
              } else if (value.includes('All Blocks') && prevBlockName && prevBlockName.includes('All Blocks')) {
                value = value.filter(item => item !== 'All Blocks');
              };
              console.log("Final value:", value, Array.isArray(value));
              // setSelectedBlockName(value);
              setSelectedMenuBlockName(value);
            }}
          />
        </MenuItem>
        <MenuItem>
          <CustomAutocomplete
            id="insight-category-selector"
            label="Insight Category"
            options={Object.keys(insightMetricOptions)}
            value={selectedInsightCategory}
            onChange={(_, value) => handleInsightCategoryChange(value)}
          />
        </MenuItem>
        <MenuItem>
          <CustomAutocomplete
            id="insight-metric-selector"
            label="Insight Metric"
            options={insightMetricOptions[selectedInsightCategory]}
            value={selectedInsightMetric}
            onChange={(_, value) => setSelectedInsightMetric(value)}
          />
        </MenuItem>
        <MenuItem>
          <Typography 
            sx={{ width: '35%' , marginLeft: '15px', color: 'rgba(0, 0, 0, 0.6)' }}
            id="range-slider-label" 
            variant="body2"
          >
            Range Filter
          </Typography>
          <Tooltip title={<Typography sx={{ fontSize: 14 }}>Filter insight values</Typography>}>
            <Slider 
              sx={{ width: '65%' ,  marginLeft: 'auto', marginRight: '15px'}}
              value={selectedSliderRange}
              onChange={(_, newValue) => setSelectedSliderRange(newValue)}
              getAriaLabel={() => 'Range Filter'}
              valueLabelDisplay='auto'
              min={props.sliderRange[0]}
              max={props.sliderRange[1]}
              step={0.1}
              size='small'
              // disabled={true}
            />
          </Tooltip>
        </MenuItem>
        <MenuItem>
          <Typography 
              sx={{ width: '92%' , marginLeft: '125px', color: 'rgba(0, 0, 0, 0.6)' }}
              id="range-slider-label" 
              variant="body2"
            >
              Plant Asset Classes
          </Typography>
          <Checkbox
            sx={{ width: '8%', marginLeft: '0px', marginRight: '0px'}}
            checked={isMaturityClassClicked}
            onChange={handleIsMaturityClassClicked}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </MenuItem>
        <MenuItem>
          <Typography 
              sx={{ width: '92%' , marginLeft: '125px', color: 'rgba(0, 0, 0, 0.6)' }}
              id="range-slider-label" 
              variant="body2"
            >
              Infrastructure Assets
          </Typography>
          <Checkbox
            sx={{ width: '8%', marginLeft: '0px', marginRight: '0px'}}
            checked={isInfraAssetClicked}
            onChange={handleIsInfraAssetClicked}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </MenuItem>
        <MenuItem sx={{justifyContent: 'flex-end'}}>
          <Tooltip title={<Typography sx={{ fontSize: 14 }}>Show selected data</Typography>}>
              <Button 
                variant="contained" 
                color="primary"
                onClick={handleSubmit}
                disabled={isButtonDisabled}
              > Submit
              </Button>
            </Tooltip>
        </MenuItem>
      </Menu>
      <Tooltip title={<Typography sx={{ fontSize: 14 }}>Image Viewer</Typography>}>
        <Fab
          color="primary"
          aria-label="image-viewer"
          onClick={handleImageViewerClick}
          style={{ position: 'fixed', top: '210px', right: '10px' }}
        >
          <ImageSearchIcon />
        </Fab>
      </Tooltip>
      <Dialog
        open={Boolean(anchorEl2)} 
        fullWidth
        maxWidth="xl"
        onClose={closeImageViewer}
      >
      <DialogContent>
        <IconButton
            sx={{justifyContent: 'flex-end'}}
            edge="start"
            color="inherit"
            onClick={closeImageViewer}
            aria-label="close"
            disableRipple={true}
          >
          <CloseIcon />
        </IconButton>
        <Typography 
            sx={{ width: '35%' , marginLeft: '20px', color: 'rgba(0, 0, 0, 0.9)' }}
            id="range-slider-label" 
          >
            Showing 25 example images
          </Typography>
        
          <ImageList sx={{ width: 'auto', height: 'auto', padding: '10px'}} cols={4}>
            {geoJsonVineDataImgUrls && geoJsonVineDataImgUrls.slice(0, 25).map((item) => (
              <ImageListItem key={item.img}>
                <img
                  src={`${item.img}`}
                  srcSet={`${item.img}`}
                  alt={item.title}
                  loading="lazy"
                />
                <ImageListItemBar
                  title={item.title}
                />
              </ImageListItem>
            ))}
          </ImageList>
      </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingInputMenu;